
import React from 'react';
import {DashboardContainer} from "../../funcs/utils";
import {sprintf} from "sprintf-js";
import {DashboardTable} from "../dashboard-table";

const STYLE_LUT = [
  {
    pred: (row, col) => row === 0,
    style: {
      background: "#CCC",
    }
  },
  {
    pred: (row, col) => true,
    style: {
      padding: "0 0.5rem",
      border: "solid black 1px",
    }
  }
];

const dump_table = ust => {
  const header = [ "Date" ];
  const [ yy, mm, dd ] = ust.date.split("-");
  const line = [sprintf("%s-%s-%s", mm, dd, yy)]

  for(let i=0; i < ust.rates.length; i++) {
    header.push(ust.rates[i].label);
    line.push(sprintf("%f", ust.rates[i].rate_pct));
  }
  const items = [ header, line ];
  const table_style = {
    width: "100%",
  }

  return (
    <DashboardTable
      tableStyle={table_style}
      tdStyleLut={STYLE_LUT}
      data={items}/>
  )
}

const USTCard = props => {
  const ust = props.ust;
  return (
    <div>
      <DashboardContainer
        client={props.client}
        title={"U.S. Treasury Yields"}>
        { dump_table(ust) }
      </DashboardContainer>
    </div>
  )
}

export { USTCard };
